import React from "react";
import { reportInfo } from "./utils/utils";
export * from "./404";
export * from "./components/components";
export * from "./HashimukhPage";
export * from "./utils/utils";
export var HashimukhContext = React.createContext({ inPrintMode: false, setPrintMode: function () { reportInfo("skipping #setPrintMode()"); } });
//# sourceMappingURL=index.js.map